import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=12884126&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=12884126&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12884126",
  null
  
)

export default component.exports